export class CurrencyService {

  format(saldo: any) {
    return Number(saldo).toLocaleString('nl-NL', {minimumFractionDigits: 2});
  }

  symbol(currency: string) {
    return {EUR: '€', DOLLAR: '$'}[currency];
  }

  euro(saldo) {
    return this.symbol('EUR') + ' ' + this.format(saldo);
  }

}
